import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=77861d7a&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=77861d7a&prod&lang=scss"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=77861d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77861d7a",
  null
  
)

export default component.exports